import './Nav.css';

function Nav() {
  return (
    <ul className="nav-list">
      <li className="nav-item nav-about selected-nav-item">
        <a href="#about">
          <span className="nav-item-dot" />
          <span className="nav-item-title">About</span>
        </a>
      </li>
      <li className="nav-item nav-experience">
        <a href="#experience">
          <span className="nav-item-dot" />
          <span className="nav-item-experience">Experience</span>
        </a>
      </li>
      <li className="nav-item nav-projects">
        <a href="#projects">
          <span className="nav-item-dot" />
          <span className="nav-item-projects">Projects</span>
        </a>
      </li>
    </ul>
  )
}

export default Nav;